import React, { useState } from "react";

import { ICardItemResponse } from "../../services/card-list/card-list.interface";
import PaymentMethodCard from "../PaymentMethodCard/PaymentMethodCard";

interface IPaymentCardList{
  cardDetailsList: ICardItemResponse[];
  defaultCard?: boolean;
  onCardSelect?: (card: ICardItemResponse ) => void;
  disableExpand?: boolean;
  enableSelection?:boolean;
  viewSortedCard?: string;
}

const PaymentCardList = (props : IPaymentCardList) => {
  const { cardDetailsList, defaultCard=false, onCardSelect,
    disableExpand=false, enableSelection=false, viewSortedCard } = props;
  const [selectedCard, setSelectedCard] = useState("");


  const cardsList = defaultCard?
    cardDetailsList.filter((card) => card.isDefault) :
    viewSortedCard ?
      cardDetailsList.filter((card) => card.id === viewSortedCard):
      cardDetailsList;

  const onCardClick = (card: ICardItemResponse)=>{
    if (onCardSelect && enableSelection) {
      setSelectedCard(card.id);
      onCardSelect(card);
    }
  };

  return (
    <div className="flex flex-col w-full gap-2">
      {cardsList.map((card: ICardItemResponse) => (
        <PaymentMethodCard
          key={card.id}
          cardDetail={card}
          isSelected={selectedCard === card.id}
          disableExpand={disableExpand}
          onCardClick={onCardClick} />
      ))}
    </div>
  );
};

export default PaymentCardList;
